module.exports = __webpack_public_path__ + "static/media/infoAlert.bfa69a00.svg";